import { useEffect, useState } from "react";
import { firebase } from "@firebase-local/firebase";
import { useEvent } from "@hooks/useEvent";

/**
 * Returns list of users from DB listener
 * @param dbRef
 */
export default function useMembersListener(dbRef: firebase.database.Query | undefined): string[] {
    const [memberUids, setMemberUids] = useState<string[]>([]);

    const handleUpdateMembers = useEvent((uids: string[]) => {
        setMemberUids([...uids]);
    });

    useEffect(() => {
        if (dbRef) {
            const dbListener = dbRef.on("value", (data) => {
                if (data.exists()) {
                    handleUpdateMembers(Object.keys(data.val()));
                } else {
                    handleUpdateMembers([]);
                }
            });

            return () => {
                dbRef.off("value", dbListener);
            };
        }
        return undefined;
    }, [dbRef]);

    return memberUids;
}
